export default "__VITE_ASSET__fxW5G$fA__"